enum Permissions {
  billeteras_banco_w = 60000,
  generacion_qr_banco_w = 60001,
}
export default Permissions;

